/**
 * @author：
 * @update：
 * @description：
 **/
// import cacheRoutes from "../../router/cacheRoutes.js";
import { userInfoHeaderHttp, scope } from "../../config/config";
import { logout } from "../../config/config";
import { messageList } from "../../api/url";
import { menuData } from "../menus";
export default {
  data() {
    return {
      userInfoHeaderHttp: userInfoHeaderHttp,
      menuData: [],
      indexActive: "/",
    };
  },
  // 自定义方法
  methods: {
    menuSelect(name) {
      this.$store.commit("setHeaderName", name);
    },
    routerChange() {
      if (this.$route.path == "/goodsDetail") {
        if (this.$route.query.type == "Not") {
          this.indexActive = "/goodsNotReviewed";
        } else {
          this.indexActive = "/goodsReviewed";
        }
      } else if (this.$route.path == "/partnerDetail") {
        this.indexActive = "/partner";
      } else if (this.$route.path == "/orderDetail") {
        this.indexActive = "/order";
      } else if (this.$route.path == "/refundDetail") {
        this.indexActive = "/refund";
      } else if (this.$route.path == "/worksDetail") {
        this.indexActive = "/works";
      } else if (this.$route.path == "/addReceptionClass") {
        this.indexActive = "/receptionClass";
      } else if (this.$route.name == "shopDetail") {
        this.indexActive = "/shop";
      } else if (
        this.$route.name == "userDetailInfo" ||
        this.$route.name == "userDetailVertify" ||
        this.$route.name == "userDetailOrder" ||
        this.$route.name == "userDetailPackage" ||
        this.$route.name == "userDetailCharge"
      ) {
        this.indexActive = "/users";
      } else if (this.$route.name == "withdrawDetail") {
        this.indexActive = "/withdraw";
      } else if (this.$route.name == "complaintShop") {
        this.indexActive = "/complaint";
      } else if (this.$route.name == "suggestionDetail") {
        this.indexActive = "/suggestion";
      } else if (this.$route.name == "evaluateDetail") {
        this.indexActive = "/evaluate";
      } else if (this.$route.path.includes("/contractManagement/")) {
        this.indexActive = "/contractManagement";
      } else {
        this.indexActive = this.$route.path;
      }
    },
    //退出登录
    goOut() {
      sessionStorage.clear();
      sessionStorage.setItem("out", "true");
      setTimeout(function () {
        window.location.href = logout;
      }, 150);
    },
    integrationMenus() {
      let data = this.$store.state.userInfo.accesses;
      window.localStorage.setItem("accesses", JSON.stringify(data));
      let arr = [];
      console.log(process.env.NODE_ENV);
      if (process.env.NODE_ENV === "development") {
        data = [
          "mall.complaint",
          "mall.receptionClass",
          "mall.mallAdministration",
          "mall.notice",
          "mall.goodsType",
          "mall.esReset",
          "mall.shop",
          "mall.role",
          "mall.goodsAttribute",
          "oauth.role",
          "mall.users",
          "mall.order",
          "mall.batchGoodsReviewed",
          "oauth.access",
          "mall.dictionary",
          "mall.journal",
          "mall.goodsReviewed",
          "oauth.admin",
          "mall.backstageClass",
          "mall.evaluation",
          "mall.echarts",
          "mall.article",
          "oauth.resource",
          "mall.refund",
          "mall.settlement",
          "mall.front",
          "mall.administrators",
          "mall.message",
          "mall.agreement",
          "oauth.client",
          "oauth.authority",
          "mall.storeMembers",
          "mall.earnings",
          "mall.suggestion",
          "mall.withdraw",
          "mall.priceAttribute",
          "oauth.user",
          "mall.works",
          "mall.goodsNotReviewed",
          "mall.normalCopyright",
          "mall.digitalCopyright",
          "mall.protectRight",
          "mall.invoiceManage",
          "mall.partnerManage",
        ];
        this.menuData = menuData;
        this.$store.commit("setOnePageHidden", true);
        return;
      }
      if (data.indexOf("mall.front") != -1) {
        arr.push({
          name: "首页",
          src1: require("../../assets/images/menuIco/1.png"),
          src2: require("../../assets/images/menuIco/1-1.png"),
          path: "/",
          children: [],
        });
        this.$store.commit("setOnePageHidden", true);
      }
      if (data.indexOf("mall.partnerManage") != -1) {
        arr.push({
          name: "合作商管理",
          src1: require("../../assets/images/menuIco/2.png"),
          src2: require("../../assets/images/menuIco/2-1.png"),
          path: "/partner",
          children: [],
        });
      }
      if (data.indexOf("mall.users") != -1) {
        arr.push({
          name: "用户管理",
          src1: require("../../assets/images/menuIco/2.png"),
          src2: require("../../assets/images/menuIco/2-1.png"),
          path: "/users",
          children: [],
        });
      }
      if (data.indexOf("mall.shop") != -1) {
        arr.push({
          name: "店铺管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          path: "/shop",
          children: [],
        });
      }
      if (data.indexOf("mall.contractManage") != -1) {
        arr.push({
          name: "签约管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          path: "/contractManagement",
          children: [],
        });
      }
      if (data.indexOf("mall.productList") != -1) {
        arr.push({
          name: "作品列表",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          path: "/listWorks",
          children: [],
        });
      }
      if (data.indexOf("mall.KBManage") != -1) {
        arr.push({
          name: "知识库管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          path: "/KBManage",
          children: [],
        });
      }
      // 新增页面添加权限判断
      if (
        data.indexOf("mall.imageCategory") != -1 ||
        data.indexOf("mall.imageNode") != -1 ||
        data.indexOf("mall.holidayHot") != -1 ||
        data.indexOf("mall.carouselMap") != -1
      ) {
        let menus = {
          name: "页面管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          children: [],
        };
        if (data.indexOf("mall.imageCategory") != -1) {
          menus.children.push({
            name: "分类管理",
            path: "/imageCategory",
          });
        }
        if (data.indexOf("mall.imageNode") != -1) {
          menus.children.push({
            name: "标签管理",
            path: "/imageNode",
          });
        }
        if (data.indexOf("mall.holidayHot") != -1) {
          menus.children.push({
            name: "节庆热点",
            path: "/holidayHot",
          });
        }
        if (data.indexOf("mall.carouselMap") != -1) {
          menus.children.push({
            name: "轮播图",
            path: "/carouselMap",
          });
        }
        if (data.indexOf("mall.showSetting") != -1) {
          menus.children.push({
            name: "展示设置",
            path: "/showSetting",
          });
        }

        arr.push(menus);
      }
      if (
        data.indexOf("mall.imageOrder") != -1 ||
        data.indexOf("mall.packagePay") != -1 ||
        data.indexOf("mall.rechargeRecord") != -1 ||
        data.indexOf("mall.packageConsumption") != -1 ||
        data.indexOf("mall.countryConsumption") != -1 ||
        data.indexOf("mall.countryIssue") != -1
      ) {
        let menus = {
          name: "交易管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          children: [],
        };
        if (data.indexOf("mall.imageOrder") != -1) {
          menus.children.push({
            name: "订单列表",
            path: "/imageOrder",
          });
        }
        if (data.indexOf("mall.packagePay") != -1) {
          menus.children.push({
            name: "套餐购买",
            path: "/packagePay",
          });
        }
        if (data.indexOf("mall.rechargeRecord") != -1) {
          menus.children.push({
            name: "充值记录",
            path: "/rechargeRecord",
          });
        }
        if (data.indexOf("mall.packageConsumption") != -1) {
          menus.children.push({
            name: "套餐消费",
            path: "/packageConsumption",
          });
        }
        if (data.indexOf("mall.countryConsumption") != -1) {
          menus.children.push({
            name: "国版币消费",
            path: "/countryConsumption",
          });
        }
        if (data.indexOf("mall.countryIssue") != -1) {
          menus.children.push({
            name: "国版币发放",
            path: "/countryIssue",
          });
        }
        arr.push(menus);
      }
      if (
        data.indexOf("mall.packageSetting") != -1 ||
        data.indexOf("mall.customPackage") != -1 ||
        data.indexOf("mall.agencyPackage") != -1 ||
        data.indexOf("mall.consultingManage") != -1
      ) {
        let menus = {
          name: "套餐管理",
          src1: require("../../assets/images/menuIco/3.png"),
          src2: require("../../assets/images/menuIco/3-1.png"),
          children: [],
        };
        if (data.indexOf("mall.packageSetting") != -1) {
          menus.children.push({
            name: "套餐设置",
            path: "/packageSetting",
          });
        }
        if (data.indexOf("mall.consultingManage") != -1) {
          menus.children.push({
            name: "咨询管理",
            path: "/consultingManagement",
          });
        }
        if (data.indexOf("mall.customPackage") != -1) {
          menus.children.push({
            name: "定制套餐",
            path: "/customPackage",
          });
        }
        if (data.indexOf("mall.agencyPackage") != -1) {
          menus.children.push({
            name: "代理套餐",
            path: "/agencyPackage",
          });
        }
        arr.push(menus);
      }
      if (data.indexOf("mall.order") != -1) {
        arr.push({
          name: "订单管理",
          src1: require("../../assets/images/menuIco/4.png"),
          src2: require("../../assets/images/menuIco/4-1.png"),
          path: "/order",
          children: [],
        });
      }
      if (data.indexOf("mall.refund") != -1) {
        arr.push({
          name: "退款管理",
          src1: require("../../assets/images/menuIco/5.png"),
          src2: require("../../assets/images/menuIco/5-1.png"),
          path: "/refund",
          children: [],
        });
      }
      if (data.indexOf("mall.settlement") != -1) {
        arr.push({
          name: "结算管理",
          src1: require("../../assets/images/menuIco/5.png"),
          src2: require("../../assets/images/menuIco/5-1.png"),
          path: "/settlement",
          children: [],
        });
      }
      if (
        data.indexOf("mall.goodsReviewed") != -1 ||
        data.indexOf("mall.goodsNotReviewed") != -1
      ) {
        let menus = {
          name: "商品管理",
          src1: require("../../assets/images/menuIco/6.png"),
          src2: require("../../assets/images/menuIco/6-1.png"),
          children: [],
        };
        if (data.indexOf("mall.goodsReviewed") != -1) {
          menus.children.push({
            name: "已审核商品",
            path: "/goodsReviewed",
          });
        }
        if (data.indexOf("mall.goodsNotReviewed") != -1) {
          menus.children.push({
            name: "待审核商品",
            path: "/goodsNotReviewed",
          });
        }
        if (data.indexOf("mall.batchGoodsReviewed") != -1) {
          menus.children.push({
            name: "批量审核通道",
            path: "/batchGoodsReviewed",
          });
        }
        arr.push(menus);
      }
      if (data.indexOf("mall.works") != -1) {
        arr.push({
          name: "作品管理",
          src1: require("../../assets/images/menuIco/7.png"),
          src2: require("../../assets/images/menuIco/7-1.png"),
          path: "/works",
          children: [],
        });
      }
      // arr = [...arr, {
      //     name: '普通版权登记管理',
      //     src1: 'el-icon-s-ticket',
      //     custmaIcon: true,
      //     path: '/general',
      //     children: [],
      // },
      // {
      //     name: '数字版权管理',
      //     src1: 'el-icon-s-release',
      //     custmaIcon: true,
      //     path: '/digitalRights',
      //     children: [],
      // },
      // {
      //     name: '版权维权管理',
      //     src1: 'el-icon-s-management',
      //     custmaIcon: true,
      //     path: '/copyrightProtection',
      //     children: [],
      // },
      // {
      //     name: '发票管理',
      //     src1: 'el-icon-s-data',
      //     custmaIcon: true,
      //     path: '/bill',
      //     children: [],
      // }]
      if (data.indexOf("mall.normalCopyright") != -1) {
        arr.push({
          name: "普通版权登记管理",
          src1: "el-icon-s-ticket",
          custmaIcon: true,
          path: "/general",
          children: [],
        });
      }
      if (data.indexOf("mall.digitalCopyright") != -1) {
        arr.push({
          name: "数字版权管理",
          src1: "el-icon-s-release",
          custmaIcon: true,
          path: "/digitalRights",
          children: [],
        });
      }
      if (data.indexOf("mall.protectRight") != -1) {
        arr.push({
          name: "版权维权管理",
          src1: "el-icon-s-management",
          custmaIcon: true,
          path: "/copyrightProtection",
          children: [],
        });
      }
      if (data.indexOf("mall.invoiceManage") != -1) {
        arr.push({
          name: "发票管理",
          src1: "el-icon-s-data",
          custmaIcon: true,
          path: "/bill",
          children: [],
        });
      }
      if (data.indexOf("mall.withdraw") != -1) {
        arr.push({
          name: "提现管理",
          src1: require("../../assets/images/menuIco/8.png"),
          src2: require("../../assets/images/menuIco/8-1.png"),
          path: "/withdraw",
          children: [],
        });
      }
      if (data.indexOf("mall.complaint") != -1) {
        arr.push({
          name: "投诉管理",
          src1: require("../../assets/images/menuIco/9.png"),
          src2: require("../../assets/images/menuIco/9-1.png"),
          path: "/complaint",
          children: [],
        });
      }
      if (data.indexOf("mall.earnings") != -1) {
        arr.push({
          name: "收益管理",
          src1: require("../../assets/images/menuIco/10.png"),
          src2: require("../../assets/images/menuIco/10-1.png"),
          path: "/earnings",
          children: [],
        });
      }
      if (data.indexOf("mall.notice") != -1) {
        arr.push({
          name: "公告管理",
          src1: require("../../assets/images/menuIco/11.png"),
          src2: require("../../assets/images/menuIco/11-1.png"),
          path: "/notice",
          children: [],
        });
      }
      if (data.indexOf("mall.suggestion") != -1) {
        arr.push({
          name: "意见反馈",
          src1: require("../../assets/images/menuIco/8.png"),
          src2: require("../../assets/images/menuIco/8-1.png"),
          path: "/suggestion",
          children: [],
        });
      }
      if (data.indexOf("mall.evaluation") != -1) {
        arr.push({
          name: "评价管理",
          src1: require("../../assets/images/menuIco/12.png"),
          src2: require("../../assets/images/menuIco/12-1.png"),
          path: "/evaluate",
          children: [],
        });
      }
      if (data.indexOf("mall.agreement") != -1) {
        arr.push({
          name: "协议管理",
          src1: require("../../assets/images/menuIco/12.png"),
          src2: require("../../assets/images/menuIco/12-1.png"),
          path: "/agreement",
          children: [],
        });
      }
      if (
        data.indexOf("mall.goodsType") != -1 ||
        data.indexOf("mall.backstageClass") != -1 ||
        data.indexOf("mall.receptionClass") != -1
      ) {
        let menus = {
          name: "分类管理",
          src1: require("../../assets/images/menuIco/13.png"),
          src2: require("../../assets/images/menuIco/13-1.png"),
          children: [],
        };
        if (data.indexOf("mall.goodsType") != -1) {
          menus.children.push({
            name: "商品类型管理",
            path: "/goodsType",
          });
        }
        if (data.indexOf("mall.backstageClass") != -1) {
          menus.children.push({
            name: "后台商品分类",
            path: "/backstageClass",
          });
        }
        if (data.indexOf("mall.receptionClass") != -1) {
          menus.children.push({
            name: "前台商品分类",
            path: "/receptionClass",
          });
        }
        arr.push(menus);
      }
      if (
        data.indexOf("mall.goodsAttribute") != -1 ||
        data.indexOf("mall.priceAttribute") != -1
      ) {
        let menus = {
          name: "属性管理",
          src1: require("../../assets/images/menuIco/14.png"),
          src2: require("../../assets/images/menuIco/14-1.png"),
          children: [],
        };
        if (data.indexOf("mall.goodsAttribute") != -1) {
          menus.children.push({
            name: "商品属性管理",
            path: "/goodsAttribute",
          });
        }
        if (data.indexOf("mall.priceAttribute") != -1) {
          menus.children.push({
            name: "定价属性管理",
            path: "/priceAttribute",
          });
        }
        arr.push(menus);
      }
      if (
        data.indexOf("mall.echarts") != -1 ||
        data.indexOf("mall.role") != -1 ||
        data.indexOf("mall.administrators") != -1 ||
        data.indexOf("mall.message") != -1 ||
        data.indexOf("mall.article") != -1 ||
        data.indexOf("mall.journal") != -1 ||
        data.indexOf("mall.rights") != -1 ||
        data.indexOf("mall.mallAdministration") != -1
      ) {
        let menus = {
          name: "系统管理",
          src1: require("../../assets/images/menuIco/15.png"),
          src2: require("../../assets/images/menuIco/15-1.png"),
          children: [],
        };
        if (data.indexOf("mall.echarts") != -1) {
          menus.children.push({
            name: "业务数据",
            path: "/echarts",
          });
        }
        if (data.indexOf("mall.role") != -1) {
          menus.children.push({
            name: "角色管理",
            path: "/role",
          });
        }
        if (data.indexOf("mall.administrators") != -1) {
          menus.children.push({
            name: "管理员管理",
            path: "/administrators",
          });
        }
        if (data.indexOf("mall.message") != -1) {
          menus.children.push({
            name: "消息管理",
            path: "/message",
          });
        }
        if (data.indexOf("mall.article") != -1) {
          menus.children.push({
            name: "文章管理",
            path: "/article",
          });
        }
        if (data.indexOf("mall.journal") != -1) {
          menus.children.push({
            name: "系统日志",
            path: "/journal",
          });
        }
        if (data.indexOf("mall.rights") != -1) {
          menus.children.push({
            name: "权益管理",
            path: "/rights",
          });
        }
        if (data.indexOf("mall.mallAdministration") != -1) {
          menus.children.push({
            name: "平台商城管理",
            path: "/mallAdministration",
          });
        }
        if (data.indexOf("mall.esReset") != -1) {
          menus.children.push({
            name: "平台ES资源重置",
            path: "/esReset",
          });
        }

        arr.push(menus);
      }
      // arr.push({
      //     name: '字典表管理',
      //     src1: require('../../assets/images/menuIco/4.png'),
      //     src2: require('../../assets/images/menuIco/4-1.png'),
      //     path: '/dictionary',
      //     children: [],
      // })
      this.indexActive = arr[0].path;
      this.menuData = arr;
    },
    messageShow() {
      let data = {
        obj: "ADMINISTRATOR",
        pageNumber: 1,
        pageSize: 1,
        haveRead: false,
      };
      this.$ajax.get(messageList, data).then(
        (res) => {
          // console.log(res);
          if (res.data.total == 0) {
            this.$store.commit("modifyIsTopBadge", false);
          } else {
            this.$store.commit("modifyIsTopBadge", true);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  // 数据观察监听
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to, from);
      this.routerChange();
      // let find = cacheRoutes.find(item => item.name === to.name);
      // if(find) {
      //     this.$store.commit("addCacheRoute", find.parent)
      // }else {
      //     this.$store.commit("addCacheRoute", "")
      // }
    },
  },
  // 计算数据
  computed: {
    avatar() {
      if (
        this.$store.state.userInfo &&
        this.$store.state.userInfo.profile &&
        this.$store.state.userInfo.profile.avatar
      ) {
        return this.$store.state.userInfo.profile.avatar;
      }
      return "";
    },
  },
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {
    this.integrationMenus();
    this.routerChange();
  },
  // 组件挂载完成之前
  beforeMount() {},
  // 组件挂载完成
  mounted() {
    this.messageShow();
    setInterval(
      function () {
        this.messageShow();
      }.bind(this),
      10000
    );
  },
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
